import { UniqueAad } from 'entities/AADGroup/interfaces';
import { BranchEditing } from 'entities/Branches/interfaces';
import { Actions } from './actions';
import {
  CLEAR_BRANCH_STATE,
  DELETE_BRANCH_ERROR,
  DELETE_BRANCH_REQUEST,
  DELETE_BRANCH_SUCCESS,
  FORCE_SAVE_BRANCH_SET,
  GET_BRANCH_ERROR,
  GET_BRANCH_REQUEST,
  GET_BRANCH_SUCCESS,
  GET_MESSAGE_CAUSE_ERROR,
  GET_MESSAGE_CAUSE_REQUEST,
  GET_MESSAGE_CAUSE_SUCCESS,
  GET_UNIQUE_AAD_REQUEST,
  GET_UNIQUE_AAD_SUCCESS,
  PUT_BRANCH_ERROR,
  PUT_BRANCH_REQUEST,
  PUT_BRANCH_SUCCESS,
  SET_SAVE_BRANCH_SET,
} from './constants';

const initialState = {
  loading: false as boolean,
  error: null as Error | null,
  branch: {} as BranchEditing,
  aad: [] as UniqueAad[],
  causes: [] as any,

  branchSaved: false,
  branchForceSave: null as null | string,
};

export type BranchState = typeof initialState;

export const branchReducer = (state: BranchState = initialState, action: Actions) => {
  switch (action.type) {
    case GET_UNIQUE_AAD_REQUEST: {
      return {
        ...state,
      };
    }
    case GET_BRANCH_REQUEST: {
      return {
        ...state,
        error: null,
        loading: true,
      };
    }
    case GET_UNIQUE_AAD_SUCCESS: {
      return {
        ...state,
        aad: action.payload,
      };
    }

    case GET_BRANCH_SUCCESS: {
      return {
        loading: false,
        error: null,
        branch: action.payload,
        branchSaved: true,
        branchForceSave: false,
      };
    }
    case DELETE_BRANCH_ERROR:
    case PUT_BRANCH_ERROR:
    case GET_BRANCH_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
        branchSaved: false,
        branchForceSave: false,
      };
    }
    case DELETE_BRANCH_REQUEST:
    case PUT_BRANCH_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case PUT_BRANCH_SUCCESS: {
      return {
        loading: false,
        error: null,
        branch: {},
        branchSaved: true,
        branchForceSave: false,
      };
    }
    case DELETE_BRANCH_SUCCESS: {
      return {
        loading: false,
        error: null,
      };
    }
    case CLEAR_BRANCH_STATE: {
      return {
        ...state,
        loading: false,
        error: null,
        branch: null,
        branchSaved: false,
        branchForceSave: false,
      };
    }
    case FORCE_SAVE_BRANCH_SET: {
      return {
        ...state,
        branchForceSave: action.payload,
      };
    }
    case SET_SAVE_BRANCH_SET: {
      return {
        ...state,
        branchSaved: action.payload,
        branchForceSave: false,
      };
    }
    case GET_MESSAGE_CAUSE_REQUEST: {
      return {
        ...state,
        causes: [],
      };
    }
    case GET_MESSAGE_CAUSE_SUCCESS: {
      return {
        ...state,
        causes: action.payload,
      };
    }
    case GET_MESSAGE_CAUSE_ERROR: {
      return {
        ...state,
        causes: [],
      };
    }
    default: {
      return state;
    }
  }
};
